import {
  Box,
  Button,
  makeStyles,
  Typography,
  withStyles
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useState, useCallback } from 'react';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import SearchInput from '../../../components/input/SearchInput';
import CreateDriverAccountModal from './CreateDriverAccountModal';

const Toolbar = ({ searchRef }) => {
  const classes = useStyles();
  const [query, setQuery] = useState({
    keyword: undefined,
    page: 1,
    page_size: PAGE_SIZE_LIST
  });

  const [openCreateModal, setOpenCreateModal] = useState(false);

  // Memoize handlers để tối ưu hiệu năng
  const handleSearchChange = useCallback(value => {
    setQuery(prevQuery => ({
      ...prevQuery,
      keyword: value || undefined,
      page: 1
    }));
  }, []);

  const handleSearch = useCallback(
    value => {
      setQuery(prevQuery => {
        const newQuery = {
          ...prevQuery,
          keyword: value || undefined,
          page: 1
        };
        if (searchRef) {
          searchRef(newQuery);
        }
        return newQuery;
      });
    },
    [searchRef]
  );

  const handleOpenCreateModal = useCallback(() => {
    setOpenCreateModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpenCreateModal(false);
  }, []);

  return (
    <div className={clsx(classes.root)}>
      {openCreateModal && (
        <CreateDriverAccountModal open={openCreateModal} onClose={closeModal} />
      )}
      <Box>
        <Box className={classes.groupSearch}>
          <div className={classes.groupSearchLeft}>
            <Typography
              style={{ fontSize: '24px', fontWeight: '600', color: '#0C1132' }}
            >
              Quản trị tài khoản lái xe
            </Typography>
          </div>
          <Box
            style={{
              marginLeft: '10px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <SearchInput
              value={query.keyword || ''}
              onChange={handleSearchChange}
              onSearch={handleSearch}
              className={'searchInputDevice'}
              placeholder="Tên, số điện thoại hoặc email"
            />
            <Button
              style={{
                marginLeft: '10px',
                color: '#ffff'
              }}
              className={classes.styleInputSearch}
              color="secondary"
              variant="contained"
              onClick={handleOpenCreateModal}
            >
              Thêm tài khoản lái xe
            </Button>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

const useStyles = makeStyles(theme => ({
  root: {},
  importButton: {
    marginRight: theme.spacing(1)
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  groupSearch: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    // overflowX: 'scroll',
    minWidth: '50%'
  },
  groupSearchLeft: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  searchInput: {
    width: '250px'
  },
  styleInputSearch: {
    height: '40px',
    textTransform: 'none',
    padding: '0px 1em'
  },
  exportBtn: {
    justifyContent: 'flex-end',
    display: 'flex',
    paddingTop: '10px',
    paddingBottom: '10px'
  },
  shadowBox: {
    boxShadow: '0 2px 5px rgba(0,0,0,.18)'
  }
}));

export default Toolbar;
